import React, { Component } from 'react';
import Pusher from 'pusher-js';
import {format} from "react-string-format";
import {NavLink} from "react-bootstrap";

class GameChats extends Component {
    constructor(props) {
        super(props);

        this.state = {
            chats: [],
            isLoaded: false
        };
    }

    loadChat(){
        this.setState({
            chats: []
        })

        fetch(process.env.REACT_APP_API_URL + "/chat/user/"+this.props.userId.toString(), {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        chats: result.chats
                    });
                },

                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    componentDidMount() {
        this.pusher = new Pusher('dc9e7b617eeeb48fb3e4', {
            cluster: 'eu',
        });
        this.channel = this.pusher.subscribe('easy-street-api.chat.1');

        this.channel.bind('pusher:subscription_succeeded', () => {
            console.log('subscribed to pusher channel');
        });

        this.loadChat();

        this.channel.bind('NewComment', data => {
            this.loadChat();
        });
    }

    render() {
        // use the state to render the chats in your component
        const { isLoaded, chats } = this.state;

        let content = null;

        if (!isLoaded){
            content = <h3>Loading chats...</h3>
        }  else {
            content = (
                <div class="alert alert-light">
                    <div class="alert alert-light">
                        {chats.map(chat => (
                            <div align="left">
                                    <div>
                                        <a style={{
                                            textDecoration: "none"
                                        }} href={"/games/" + chat.game.id.toString()}>
                                        <h4>{chat.game.name}</h4>

                                            <img width="80" style={{
                                            borderRadius: 5
                                        }} src={chat.game.game_page ? chat.game.game_page.icon_url : "#"}></img>

                                        </a>
                                        <span style={{
                                            backgroundColor: "#b3ccff",
                                            width: 200,
                                            borderRadius: 5,
                                            paddingInline: 10,
                                            paddingBlock: 10,
                                            marginBottom: 20,
                                            marginTop: 20,
                                            marginLeft: 5
                                        }}>
                                            {
                                                chat.last_message.user.first_name + ": " + chat.last_message.message
                                            }
                                        </span>
                                    </div>
                                <br/>
                            </div>
                        ))}
                    </div>
                </div>
            );
        }

        return content;
    }
}

export default GameChats;
